/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {LogOut} from "lucide-react";

export const Logout: React.FC = () => {
    const { logout } = useAuth();

  return (
    <div>
        <LogOut size={24} color="black" onClick={logout} style={{cursor: "pointer"}} />
    </div>
  );
};
